/*
 * custom-faq.js
 * FAQアコーディオンの開閉トグル（イベント委譲）。
 * 開閉アニメーションはCSS（.ls-faq-a-wrap の grid-template-rows: 0fr -> 1fr）が担当し、
 * ここでは .ls-faq-item に .is-open を付け外しし、aria-expanded を同期するだけ。
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var button = target.closest('.ls-faq-q');
    if (!button) return;

    var item = button.closest('.ls-faq-item');
    if (!item) return;

    var isOpen = item.classList.toggle('is-open');
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
})();
